import CryptoJS from 'crypto-js';

// Convert key and IV to WordArray (MUST match PHP raw binary)
// const KEY = CryptoJS.enc.Utf8.parse('rasvod2uniwse0231n04o129qriwo62l'); // 32-byte key
const IV = CryptoJS.enc.Utf8.parse(
	'\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00',
); // 16-byte IV

export const hashMD5 = (data: string) => {
	const md5Key = CryptoJS.MD5(data).toString();
	return CryptoJS.enc.Utf8.parse(md5Key);
};

// Encrypt function (returns Hex)
export const encryptData = (data: object, key: string): string => {
	const KEY = hashMD5(key);
	const jsonString = JSON.stringify(data);
	const encrypted = CryptoJS.AES.encrypt(jsonString, KEY, {
		iv: IV,
		mode: CryptoJS.mode.CBC,
		padding: CryptoJS.pad.Pkcs7,
	});
	return CryptoJS.enc.Hex.stringify(CryptoJS.enc.Base64.parse(encrypted.toString()));
};

// Decrypt Data
export const decryptData = (encryptedHex: string, key: string) => {
	// Check if encryptedHex is valid
	if (!encryptedHex || typeof encryptedHex !== 'string') {
		console.error('decryptData: Invalid encryptedHex parameter:', encryptedHex);
		return null;
	}

	try {
		const KEY = hashMD5(key);
		// Convert Hex to Base64
		const encryptedBase64 = CryptoJS.enc.Hex.parse(encryptedHex).toString(CryptoJS.enc.Base64);

		// Decrypt
		const decrypted = CryptoJS.AES.decrypt(encryptedBase64, KEY, {
			iv: IV,
			mode: CryptoJS.mode.CBC,
			padding: CryptoJS.pad.Pkcs7,
		});

		// Convert decrypted text to JSON
		const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
		
		// Check if decryption was successful
		if (!decryptedText) {
			console.error('decryptData: Failed to decrypt data');
			return null;
		}
		
		return JSON.parse(decryptedText);
	} catch (error) {
		console.error('decryptData: Error during decryption:', error);
		return null;
	}
};
